let initialState = {
  loaiDonThu: [],
  huongXuLy: [],
  huongXuLyDon: [],
  nguonDon: [],
  loaiTaiLieuList: [],
  tinhTrangTaiLieuList: [],
  phanLoaiNguoiDungDonList: [],
  loaiTepDinhKemList: [],
  notifyTongXLD: {tongSoDon: 0},
  notifyTongDonDK: {tongSoDon: 0},
  notifyTongGQD: {tongSoDon: 0},
  notifyTongDonDX: {tongSoDon: 0},
  notifyTongDonYC: {tongSoDon: 0},
  notifyTongDonTDTH: {tongSoDon: 0},
  notify: {},
  initIDTP: false,
  showForm: false,
  init: false
}

function duLieuHeThong(state = initialState, action) {
  switch (action.type) {
    case 'CAPNHAT_DULIEUHETHONG':
      let newState = {
        ...state
      };
      action.duLieuHeThong.map((dulieu, i) => {
        newState[dulieu.key] = dulieu.data;
      });
      return newState;
    case 'INIT_DULIEU':
      newState = {
        ...state,
        init: action.value
      };
      return newState;
    case 'GET_TPID':
      newState = {
        ...state,
        initIDTP: action.value
      };
      return newState;
    case 'NEW_MSG':
      newState = {
        ...state,
        notify: action.data
      };
      return newState;
    case 'REFRESH_MENU':
      newState = {
        ...state,
        refreshMenu: action.value
      };
      return newState;
    case 'UPDATE_TONGDON':
      newState = {
        ...state,
        [action.key]: {tongSoDon: action.value}
      };
      return newState;
    case 'RESET_DLHT':
      newState = {
        ...state,
        huongXuLyDon: [],
        ketQuaTiepDan: [],
        coQuanTiepNhan: [],
        ketLuanNoiDungKhieuNai: [],
        ketQuaThucHien: [],
        lanhDaoList: [],
        thamSo: [],
        loaiDonThu: [],
        huongXuLy: [],
        nguonDon: [],
        loaiTaiLieuList: [],
        tinhTrangTaiLieuList: [],
        phanLoaiNguoiDungDonList: [],
        loaiTepDinhKemList: [],
        ketQuaGiaiQuyetDon: [],
        noiCapCMND: [],
        donViTTXM: [],
        coQuanTiepDanList: [],
        loaiDoiTuong: [],
        donViHanhChinh: [],
        donViChuTri: [],
        loaiVuViecList: [],
        capCoQuanDaGiaiQuyet: [],
        coQuanDaGiaiQuyet: [],
        danToc: [],
        donViThongKe: [],
        hinhThucDaGiaiQuyet: [],
        huongGiaiQuyetCuaLanhDao: [],
        ketQuaGiaiQuyetLanHai: [],
        capQuanHuyen: [],
        loaiKyThongKe: [],
        namThongKe: [],
        loaiQuyThongKe: [],
        thangThongKe: [],
        nhomThamQuyenGiaiQuyet: [],
        phongBanThuocCoQuan: [],
        capPhuongXa: [],
        quocTich: [],
        capTinhThanhPho: [],
        trangThaiDon: [],
        coQuanDieuTra: [],
        init: false
      };
      return newState;
      case 'DISPLAY_FORM':
      newState = {
        ...state,
        showForm: action.value
      };
      return newState;
    default:
      return state;
  }
}

export { duLieuHeThong }



// WEBPACK FOOTER //
// ./src/reducers/duLieuHeThong.js